// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"NX-z","sponsoredTooltipWrapper":"OX-z","sponsoredTooltip":"PX-z","newCard":"QX-z"};